// ─────────────────────────────────────────────────────────────────
// Glass-i — RFQ API client (Stage 6RFQ). Thin axios wrappers around
// /api/erp/rfq/*. Backend is the source of truth; payloads pass through.
// ─────────────────────────────────────────────────────────────────

import client from '../../../api/client';

const BASE = '/api/erp/rfq';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const rfqApi = {
  list:         (params = {})       => client.get(BASE, { params }).then(unwrap),
  get:          (id)                => client.get(`${BASE}/${id}`).then(unwrap),
  createFromPr: (prId, payload)     => client.post(`${BASE}/from-pr/${prId}`, payload).then(unwrap),
  updateDraft:  (id, payload)       => client.put(`${BASE}/${id}`, payload).then(unwrap),
  addVendors:   (id, supplierIds)   => client.post(`${BASE}/${id}/vendors`, { supplier_ids: supplierIds }).then(unwrap),
  removeVendor: (id, vendorId)      => client.delete(`${BASE}/${id}/vendors/${vendorId}`).then(unwrap),
  send:         (id, vendorIds = []) => client.post(`${BASE}/${id}/send`, { vendor_ids: vendorIds }).then(unwrap),
  recordQuote:  (id, vendorId, payload) => client.post(`${BASE}/${id}/vendors/${vendorId}/quote`, payload).then(unwrap),
  compare:      (id)                => client.get(`${BASE}/${id}/compare`).then(unwrap),
  award:        (id, rfqVendorId)   => client.post(`${BASE}/${id}/award`, { rfq_vendor_id: rfqVendorId }).then(unwrap),
  cancel:       (id, reason)        => client.post(`${BASE}/${id}/cancel`, { reason }).then(unwrap),
  // Printable document HTML (fetched via the api client so the auth
  // header rides along; shown in an in-app iframe viewer).
  reportHtml:   (id, vendorId) =>
    client.get(`${BASE}/${id}/report`, {
      params: vendorId ? { vendorId } : {}, responseType: 'text'
    }).then((r) => r.data)
};

export default rfqApi;
